<template>
  <div class="page flex-col justify-end">
    <SiteHeader />
    <div class="box_1 flex-col">
      <!-- 科研大图 -->
      <div v-if="researchData.banner && researchData.banner.length > 0" class="banner-container">
        <img 
          v-for="banner in researchData.banner" 
          :key="banner.id"
          :src="banner.image.replace(/`/g, '')"
          :alt="banner.title"
          class="banner-image"
        />
      </div>
    </div>
    <div class="group_6 flex-col">
      <div class="block_1 flex-col">
        <div class="text-wrapper_20 flex-row justify-between">
          <span class="text_4">科技引领发展</span>
          <span class="text_5">致力于与全球伙伴共同推动生物医药创新</span>
        </div>
        <div class="section_13 flex-row justify-between">
          <div
            class="text-wrapper_2 flex-col stat-card"
            :class="statActiveIndex === 0 ? 'stat-card--active' : 'stat-card--inactive'"
            @click="setActiveStat(0)"
            @mouseenter="setActiveStat(0)"
          >
            <span class="text_6">研发团队占比公司人员</span>
            <span class="text_7">80%+</span>
          </div>
          <div
            class="text-wrapper_3 flex-col stat-card"
            :class="statActiveIndex === 1 ? 'stat-card--active' : 'stat-card--inactive'"
            @click="setActiveStat(1)"
            @mouseenter="setActiveStat(1)"
          >
            <span class="text_8">每年研发资金投入占比</span>
            <span class="text_9">60%+</span>
          </div>
          <div
            class="text-wrapper_4 flex-col stat-card"
            :class="statActiveIndex === 2 ? 'stat-card--active' : 'stat-card--inactive'"
            @click="setActiveStat(2)"
            @mouseenter="setActiveStat(2)"
          >
            <span class="text_10">拥有国内各项有效知识产权</span>
            <span class="text_11">12项</span>
          </div>
        </div>
      </div>
      <div class="block_2 flex-col" @mouseenter="stopAnchorTimer" @mouseleave="startAnchorTimer">
        <div class="group_7 flex-row justify-between">
          <div class="text-wrapper_5 flex-col"><span class="text_12">科研实力</span></div>
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngf1b0e83386d6b9dec32550a78097be6598ea11c77e19fb6b7ecd8a76c86a1866.png"
          />
        </div>
        <div class="text-wrapper_21 flex-row"><span class="text_13">{{ currentAnchor.sectionTitle }}</span></div>
        <div class="group_8 flex-row justify-between">
          <div class="text-wrapper_22 flex-col justify-between">
            <span class="text_14">{{ currentAnchor.title }}</span>
            <span class="text_15" v-html="currentAnchor.body"></span>
          </div>
          <div class="box_6-wrapper flex-col">
            <div class="box_6 flex-col"></div>
          </div>
        </div>
        <div class="image-wrapper_5 anchor-controls flex-row">
          <button
            class="anchor-control anchor-control--left"
            type="button"
            :disabled="anchorIndex === 0"
            aria-label="上一条"
            @click="prevAnchor"
          ></button>
          <button
            class="anchor-control anchor-control--right"
            type="button"
            :disabled="anchorIndex === anchorItems.length - 1"
            aria-label="下一条"
            @click="nextAnchor"
          ></button>
          <img
            class="research-patent-badge"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng3e030af5cace0d348c3d9e44f6608a16b1d9de4387a02118d808f0c037ca72b2.png"
            alt="研发专利"
          />
        </div>
      </div>
    </div>
    <div class="box_7 flex-col">
      <div class="box_8 flex-col">
        <div class="box_9 flex-col">
          <span class="text_16">联合昭衍新药与兰州大学权威团队</span>
          <div class="text-wrapper_8">
            <span class="text_17">昭衍新药是国际公认的顶尖非临床安全性评价机构，其遵循FDA</span>
            <span class="paragraph_1">
              /EMA等全球监管机构的严格标准，为产品构筑了坚实可靠的安全屏障。
              <br />
            </span>
            <span class="paragraph_2"><br /></span>
            <span class="text_18">
              兰州大学作为国家“双一流”重点高校，其权威科研团队依托国家级实验室平台，以创新性研究方法为我们产品的有效性提供了里程碑式的实证支持。
            </span>
          </div>
        </div>
      </div>
      <div class="box_10 flex-col">
        <div class="group_2 flex-col">
          <span class="text_19">国家“重大新药创制”科技重大专项支持项目</span>
          <div class="text-wrapper_9">
            <span class="paragraph_3">
              对于关注我们的每一位伙伴而言，这代表：
              <br />
            </span>
            <span class="paragraph_4">
              &nbsp;
              <br />
            </span>
            <span class="text_20">对患者与医务工作者：这是一款承載国家战略期待的重点在研药物，</span>
            <span class="paragraph_5">
              是应对心脑血管血栓这一重大健康威助的、极具前景的末来选项之一。
              <br />
            </span>
            <span class="paragraph_6"><br /></span>
            <span class="text_21">
              对合作方与投资者：这是一个科学价值与开发风险已获得国家最高层面第三方权威背书的项目，其发展路径具有更高的确定性与公信力。
            </span>
          </div>
        </div>
      </div>
    </div>
    <SiteFooter variant="research" />
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: 'ResearchPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      researchData: {
        banner: [],
        list: []
      },
      statActiveIndex: -1,
      anchorIndex: 0,
      anchorTimer: null,
      anchorItems: []
    };
  },
  computed: {
    currentAnchor() {
      return this.anchorItems[this.anchorIndex] || {};
    }
  },
  methods: {
    async fetchResearchData() {
      try {
        const response = await fetch('/api/pc/kysl');
        const data = await response.json();
        if (data.code === 1) {
          this.researchData = data.data;
          this.replaceImageDomain();
          this.updateAnchorItems();
        }
      } catch (error) {
        console.error('Failed to fetch research data:', error);
      }
    },
    replaceImageDomain() {
      if (!this.researchData) return;
      
      const replaceDomain = (obj) => {
        if (!obj) return;
        if (obj.image) {
          obj.image = obj.image.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
        if (obj.content) {
          obj.content = obj.content.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
        if (obj.abstract) {
          obj.abstract = obj.abstract.replace(/vitalang\.36ysk\.com/g, 'www.haoronbio.com');
        }
      };
      
      if (this.researchData.image) {
        replaceDomain(this.researchData);
      }
      if (this.researchData.list) {
        this.researchData.list.forEach(replaceDomain);
      }
    },
    updateAnchorItems() {
      this.anchorItems = (this.researchData.list || []).map(item => ({
        sectionTitle: item.title,
        title: item.abstract,
        body: item.content || ''
      }));
    },
    setActiveStat(index) {
      this.statActiveIndex = index;
    },
    startAnchorTimer() {
      this.stopAnchorTimer();
      this.anchorTimer = setInterval(() => {
        if (this.anchorItems.length <= 1) return;
        this.anchorIndex = (this.anchorIndex + 1) % this.anchorItems.length;
      }, 5000);
    },
    stopAnchorTimer() {
      if (this.anchorTimer) {
        clearInterval(this.anchorTimer);
        this.anchorTimer = null;
      }
    },
    resetAnchorTimer() {
      this.startAnchorTimer();
    },
    prevAnchor() {
      if (this.anchorIndex <= 0) return;
      this.anchorIndex -= 1;
      this.resetAnchorTimer();
    },
    nextAnchor() {
      if (this.anchorIndex >= this.anchorItems.length - 1) return;
      this.anchorIndex += 1;
      this.resetAnchorTimer();
    }
  },
  mounted() {
    this.fetchResearchData();
    this.startAnchorTimer();
  },
  beforeDestroy() {
    this.stopAnchorTimer();
  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />
<style scoped>
.banner-container {
  width: 100%;
  overflow: hidden;
}
.banner-image {
  width: 100%;
  height: auto;
  display: block;
}
/* 确保样式能正确应用到v-html渲染的内容 */
.text_15 >>> p {
  margin: 0;
  padding: 0;
  line-height: 1.5;
}
</style>
